import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/App/context/AuthContext";
import nextImg from "src/assets/next.svg";
import "./style.scss";

const STEP = { EMAIL: "email", CODE: "code", DONE: "done" };

const Reset = () => {
  const [step, setStep] = useState(STEP.EMAIL);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { resetPassword, confirmResetPassword } = useAuth();
  const navigate = useNavigate();

  const onRequestReset = async () => {
    if (!email) return;
    setError("");
    setLoading(true);
    try {
      await resetPassword(email);
      setStep(STEP.CODE);
    } catch (err) {
      setError(
        err.code === "UserNotFoundException"
          ? "No account found with that email."
          : err.message || "An error occurred."
      );
    } finally {
      setLoading(false);
    }
  };

  const onConfirmReset = async () => {
    if (!code || !newPassword) return;
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await confirmResetPassword(email, code, newPassword);
      setStep(STEP.DONE);
    } catch (err) {
      setError(err.message || "Invalid code or password.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e, fn) => {
    if (e.key === "Enter") fn();
  };

  if (step === STEP.DONE) {
    return (
      <div className="reset-page">
        <div className="content">
          <p className="prompt">Password updated successfully.</p>
          <div className="control-div">
            <span onClick={() => navigate("/login")}>back to login</span>
          </div>
        </div>
      </div>
    );
  }

  if (step === STEP.CODE) {
    return (
      <div className="reset-page">
        <div className="content">
          {error && <p className="error-message">{error}</p>}
          <p className="prompt">Enter the code sent to {email}</p>
          <input
            type="text"
            placeholder="verification code"
            value={code}
            onChange={e => setCode(e.target.value)}
            onKeyDown={e => handleKeyDown(e, onConfirmReset)}
            autoFocus
          />
          <br />
          <input
            type="password"
            placeholder="new password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            onKeyDown={e => handleKeyDown(e, onConfirmReset)}
          />
          <br />
          <input
            type="password"
            placeholder="confirm password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            onKeyDown={e => handleKeyDown(e, onConfirmReset)}
          />
          <div className="control-div">
            <span onClick={() => navigate("/login")}>back to login</span>
            <img
              src={nextImg}
              alt="next"
              onClick={onConfirmReset}
              className={loading ? "loading" : ""}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-page">
      <div className="content">
        {error && <p className="error-message">{error}</p>}
        <p className="prompt">Enter your email to reset password</p>
        <input
          type="text"
          placeholder="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => handleKeyDown(e, onRequestReset)}
          autoFocus
        />
        <div className="control-div">
          <span onClick={() => navigate("/login")}>back to login</span>
          <img
            src={nextImg}
            alt="next"
            onClick={onRequestReset}
            className={loading ? "loading" : ""}
          />
        </div>
      </div>
    </div>
  );
};

export default Reset;
